module.exports = __webpack_public_path__ + "img/6.fda1b7e.png";